// extracted by mini-css-extract-plugin
module.exports = {"mainSvg":"OrientationLandscape_mainSvg__1F2bD","activeColor":"OrientationLandscape_activeColor__cq-Le","defaultColor":"OrientationLandscape_defaultColor__1lbWH"};